import { useSelector } from "react-redux";

import { FORM_ID } from "@/components/Account/ForgotPasswordForm/forgotPasswordForm.component";
import { ForgotPasswordForm } from "@/components/Account/ForgotPasswordForm/forgotPasswordForm.container";
import { RouterModal } from "@/components/General/Modal/routerModal";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export const ForgotPasswordModal = () => {
    const { t } = useGranite();

    const isPending = useSelector(CustomerSelectors.isLoading);

    return (
        <RouterModal
            modalType={ModalType.ForgotPassword}
            title={t("modal.forgot-password.title")}
            confirmButtonText={t("modal.forgot-password.confirm")}
            isLoading={isPending}
            formId={FORM_ID}
        >
            <ForgotPasswordForm
                notification={t("modal.forgot-password.description")}
            />
        </RouterModal>
    );
};
